import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useSafeNavigate } from '@/shared/lib/safe-navigate'
import { getCookie } from '@/shared/lib/formatter'

export function useHandleNavigation(): void {
  const navigate = useSafeNavigate()
  const location = useLocation()
  const hasNavigatedRef = useRef(false)
  const mountedRef = useRef(false)

  useEffect(() => {
    if (mountedRef.current) return
    mountedRef.current = true

    if (hasNavigatedRef.current) return

    const currentPath = getCookie('currentPath')
    const currentPathname = location.pathname + location.search

    if (
      currentPath &&
      currentPath !== currentPathname &&
      !currentPath.includes('/login') &&
      location.pathname !== '/login'
    ) {
      hasNavigatedRef.current = true
      navigate(currentPath, { replace: true })
    } else {
      hasNavigatedRef.current = true
    }

    return () => {
      // Cleanup for Strict Mode
    }
  }, [navigate, location.pathname, location.search])
}

export default useHandleNavigation
